import React from 'react';
import { ChevronRight } from 'lucide-react';

interface CheckoutShippingMethodProps {
  handleShippingMethodChange: (method: string) => void;
  selectedMethod: string;
}

export function CheckoutShippingMethod({ handleShippingMethodChange, selectedMethod }: CheckoutShippingMethodProps) {
  const shippingMethods = [
    'DPD Pakiautomaat', 
    'Smartposti Pakiautomaat', 
    'Omniva Pakiautomaat'
    // 'Tulen ise järgi' // Temporarily commented out
  ];

  return (
    <div className="space-y-6">
      <h2 className="text-2xl font-bold">Vali transpordi viis</h2>
      <div className="space-y-4">
        {shippingMethods.map((method) => (
          <label key={method} className={`flex items-center p-4 border rounded-lg cursor-pointer ${
            selectedMethod === method ? 'border-[#4FC1E9] bg-[#4FC1E9]/5' : 'hover:border-[#4FC1E9]'
          } transition-colors`}>
            <input
              type="radio"
              name="shippingMethod"
              value={method}
              checked={selectedMethod === method}
              onChange={(e) => handleShippingMethodChange(e.target.value)}
              className="text-[#4FC1E9] focus:ring-[#4FC1E9]"
            />
            <span className="ml-3">{method}</span>
            <span className="ml-auto text-green-600 font-medium">TASUTA</span>
          </label>
        ))}
      </div>
    </div>
  );
}